import { useEffect, useState } from "react";
import "./index.css";

import logo from "./logo.svg";
import { type ProjectDTO } from "./models/project";

export function App() {
  const [projects, setProjects] = useState<ProjectDTO[]>([]);

  async function getProjects() {
    const res = await fetch("/api/projects");
    if (!res.ok) {
      throw new Error("Non-ok status");
    }
    const data = await res.json();
    return data;
  }

  useEffect(() => {
    // Get projects
    getProjects().then((projects) => {
      setProjects(projects);
    });
  }, []);

  return (
    <div className="max-w-7xl mx-auto p-8 text-center relative z-10">
      <div className="flex justify-center items-center gap-8">
        <img
          src={logo}
          alt="knutegil.dev logo"
          className="h-24 p-6 transition-all duration-300 hover:drop-shadow-[0_0_2em_#646cffaa] scale-120"
        />
      </div>

      <h1 className="text-4xl font-bold leading-tight mb-4">My projects</h1>
      <div>
        {projects.map((project) => {
          return (
            <div id={project.id}>
              <a href={project.url} className="underline">
                <h2 className="text-2xl font-bold leading-tight text-left">
                  {project.name}
                </h2>
              </a>
              <p className="text-md text-left">{project.description}</p>
              <div className="flex gap-2 opacity-60 justify-between">
                <small className="text-left">
                  [ {project.tags.map((tag) => tag).join(" / ")} ]
                </small>
                <small className="text-left">
                  Created at {new Date(project.updatedAt).toLocaleString()}
                </small>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default App;
